"use client";

import { QuestionMarkCircleIcon } from "@heroicons/react/24/solid";

import { HTMLMarkdown } from "@/components/markdown/HTMLMarkdown";
import { useDialog } from "@/hooks/use-dialog";
import { useLang } from "@/hooks/use-lang";

import { Button } from "ui/core/button";

export const InvestStyleDialogToggle = () => {
  const { t } = useLang();
  const { Dialog, openDialog, closeDialog } = useDialog({
    isMobileFullScreen: false,
  });

  return (
    <>
      <QuestionMarkCircleIcon
        onClick={openDialog}
        className="hidden h-5 w-5 shrink-0 cursor-pointer text-zinc-400 hover:text-zinc-500 @3xl:block"
      />
      <Dialog title={t.winwingpt.investStyleDialog.title}>
        <div className="flex flex-col gap-5 p-6">
          <HTMLMarkdown>{t.winwingpt.investStyleDialog.content}</HTMLMarkdown>
          <Button className="mx-auto w-full max-w-sm" onClick={closeDialog}>
            {t.winwingpt.investStyleDialog.close}
          </Button>
        </div>
      </Dialog>
    </>
  );
};
